module.exports = __webpack_public_path__ + "static/img/frame.09fae391.png";